export default __webpack_public_path__ + "static/media/downJoystickArrow.2d9be1cf.svg";